import { captureException } from '@sentry/react'
import { Component, ReactNode } from 'react'

type QodanaErrorBoundaryProps = {
	errorTemplate: ReactNode
}

export class QodanaErrorBoundary extends Component<
	QodanaErrorBoundaryProps,
	{ hasError: boolean }
> {
	constructor(props: QodanaErrorBoundaryProps) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error: unknown) {
		captureException(error)
	}

	render() {
		if (this.state.hasError) {
			return this.props.errorTemplate
		}

		return this.props.children
	}
}
